<template>
  <div @click.prevent="$parent.$parent.$emit('route', '/')">
    <div  class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div v-if="title" class="modal-header">
            <slot name="header">
              {{ $t(title) }}
            </slot>
          </div>

          <div class="modal-description">
            <slot name="description">
              <div class="col-xs-12">
                {{ $t(message) }}
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h2: "",
      h1: "",
    };
  },
  computed: {
    message() {
      return window.location.pathname.split("/").pop();
    },
    title() {
      return '';
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-description {
  margin: 20px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}
.modal-container {
  width: 500px;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.btn {
  margin-right: 0px;
}
</style>
